import { Singleton } from 'app/utils';
import { HttpResource } from 'app/resources';

export class IdentityResource extends HttpResource {

    public unsetToken: () => void = () => {};

    public setEnvironment(env: string = 'prod') {
        env = (env === 'local') ? 'dev' : env;
        env = (env !== 'prod') ? env + '.' : '';
        super.setBaseUrl(`https://${env}id.spsc.io/identity/`);
    }

    /**
     * Sets the authorization headers for identity based on the input token
     * @param  {string} token
     */
    public setToken = (token: string) => {
        this.unsetToken();
        this.unsetToken = super.addHeader({
            name: 'Authorization',
            data: `Bearer ${token}`
        });
    }

}

export let $IdentityResource = Singleton('$IdentityResource', IdentityResource);
